import { render, staticRenderFns } from "./BuyDomain.vue?vue&type=template&id=2bc30b22&scoped=true"
import script from "./BuyDomain.vue?vue&type=script&lang=js"
export * from "./BuyDomain.vue?vue&type=script&lang=js"
import style0 from "./BuyDomain.vue?vue&type=style&index=0&id=2bc30b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc30b22",
  null
  
)

export default component.exports